export function handleFileDownload(response) {
  /* Function to pass a data file downloaded from the API.
   *
   * The logic used is that the response is parsed for key facts such as the
   * filename and type of content.
   *
   * These facts are then used to setup an in-memory blob to hold the file. A
   * link is then created to the file and automatically 'clicked' to start the
   * download.
   *
   * The link and file is then removed.
   *
   */
  // Get the content type
  let contentType = "";
  if (response.headers["content-type"]) {
    contentType = response.headers["content-type"];
  } else {
    contentType = "application/data";
  }
  // Get the filename
  const contentDisposition = response.headers["content-disposition"];
  let fileName = "report.pdf";
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/(filename=)(.+)/);
    fileName = fileNameMatch.slice(-1).pop();
  }
  // Setup a blob to hold the file data
  let blob = new Blob([response.data], { type: contentType });
  // Create a (temporary) link to the blob to download it
  let url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.setAttribute("download", fileName);
  link.setAttribute("type", contentType);
  document.body.appendChild(link);

  return link;
  // NOTE: It may be necessary to handle this in the onClick function directly
  // to avoid popup blockers.
  //
  // Either copy-paste this code ore add `return link` here and add the
  // following code directly into the onClick() function.
  // link.click();
  // setTimeout( () => {
  //   link.remove();
  //   window.URL.revokeObjectURL(link.href);
  // }, 5000);
}
